import * as React from "react";
import { IconCloudDemo } from "@/components/IconCloudDemo";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/lib/userType.js";
import ToggleTheme from "@/components/ToggleTheme.js";
import AuthForm from "./AuthForm.js";
import logo from "@/assets/robotwala1.png";

const Authentication = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <div className="max-h-screen relative flex lg:flex-row min-h-screen bg-background text-foreground overflow-x-hidden">
      {/* Theme Switcher - Cleanly placed at top right on all screens */}
      <div className="absolute right-6 top-6 z-50 flex items-center gap-2">
        <ToggleTheme />
      </div>

      {/* Left side: Icon/Banner Cloud (Desktop only) */}
      {/* <IconCloudDemo /> */}

      {/* Right side: Authentication Form Panel */}
      <div className="w-full flex flex-col justify-center items-center p-6 sm:p-12 md:p-16 lg:p-20 min-h-screen">
        <div className="w-full max-w-md mx-auto flex flex-col items-center space-y-8 animate-fade-in">
          {/* Logo - Centered above the greeting */}
          <div className="flex items-center">
            <img
              src={logo}
              alt="Robotwala"
              className="h-24 w-auto object-contain select-none"
            />
            <h1 className="text-2xl font-bold text-red-700 uppercase">
              robotwala
            </h1>
          </div>

          <div className="text-center w-full space-y-2">
            {/* <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text text-transparent">
              Robotwala
            </h1> */}
            <p className="text-sm text-muted-foreground text-md">
              Sign in to access your student portal
            </p>
          </div>

          <div className="w-full bg-card border border-border/50 shadow-2xl rounded-2xl p-6 sm:p-8 backdrop-blur-sm">
            <AuthForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authentication;
